import React, { useContext } from 'react';
import { useNavigate, useParams } from 'react-router';

import { DASHBOARD } from '../../../../routes/routeConstants';
import StatusCell from '../../../Badge/StatusCell';
import Table from '../../../Table/Table';
import TableHasConflictTag from '../../../Table/TableAccessories/TableHasConflictTag';
import TableScroller from '../../../Table/TableScroller';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';
import PlainSuccessModal from '../../PlainSuccessModal';

const DispatcherActiveCompanyModal = () => {
  const modalContext = useContext(ModalContext);
  const { ninNumber } = useParams();
  const navigate = useNavigate();

  const successActionFn = () => {
    modalContext?.setShowModal(false);
    navigate(`/${DASHBOARD}`);
  };

  return (
    <ModalContainer
      width={!modalContext?.showSuccessComponent ? '600px' : undefined}
      label='View Active Company List'
      successComponent={() => (
        <PlainSuccessModal
          successActionFn={successActionFn}
          description='The driver has been successfully hired.'
          btnLabel='Go to Dashboard'
          // className='pink'
        />
      )}
      showSuccessComponent={modalContext?.showSuccessComponent}
    >
      <TableScroller>
        <Table
          className='scrollable-table'
          tableHeader={{
            'Name of Company': 'companyName',
            'Start Date': 'startDate',
            'Hiring Type': 'employmentType',
          }}
          tableDataSourceUrl={`api/v1/dispatchers/active-engagements?nin=${ninNumber}`}
          cellsCustomComp={{
            hiringEligibility: <StatusCell statusKey='hiringEligibility' />,
            companyName: (
              <TableHasConflictTag
                dataKey='companyName'
                totalConflictsKey='triggeredConflict'
              />
            ),
          }}
          continuousView
        />
      </TableScroller>
    </ModalContainer>
  );
};

export default DispatcherActiveCompanyModal;
